import React, {useEffect} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useHistory} from "react-router-dom";
import {useLoggedIn} from "../../store";
import useFeedback from "../../utils/use_feedback";
import {useReport} from "../../api/report";
import {useCommunityReportReasons} from "../../api/report_reasons";
import useForm from "../../utils/use_form";
import RadioInputs from "../radio_inputs";
import {Button, Header, Title} from './sheet';

const ReportSheet = styled(({className, id, isPost, community, onClose}) => {

    const history = useHistory();
    const loggedIn = useLoggedIn();
    const {error: reportError, feedbackCh: reportCh} = useFeedback(true);
    const report = useReport(reportCh);
    const {error, feedbackCh} = useFeedback();
    const customReasons = useCommunityReportReasons(feedbackCh, community)?.rules;
    const [values, Provider] = useForm({reportReason: "", customReason: ""});

    useEffect(() => {
        if (!loggedIn && values.reportReason) {
            // Is this the desired behavior?
            history.push('/registration');
        }
    }, [loggedIn, values, history]);

    const showCustomReasons = values.reportReason === 'communityRules' && customReasons.length > 0;
    const handleReport = async () => {
        onClose();
        try {
            await report(
                id,
                isPost,
                values.reportReason,
                values.reportReason === 'communityRules' ? values.customReason : ''
            );
        } catch {
            // error is displayed
        }
    };

    return (
        <div className={className}>

            <Header>
                <Title>Report</Title>
                {values.reportReason && (!showCustomReasons || values.customReason) &&
                    <Button onClick={handleReport}>Send</Button>
                }
            </Header>

            <Provider>
                {!showCustomReasons && (
                    <RadioInputs name="reportReason" childrenStyle={{marginBottom: 24}} labelStyle={{marginLeft: 8}}>
                        <option value="communityRules">
                            {`Breaks c/${community}'s rules`}
                        </option>
                        <option value="spam">Spam or Self Promotion</option>
                        <option value="platformMisuse">Platform Misuse</option>
                        <option value="csam">Sexualization of Minors</option>
                        <option value="illegalContent">Other Illegal Content</option>
                    </RadioInputs>
                )}
                {showCustomReasons && (
                    <RadioInputs name="customReason" childrenStyle={{marginBottom: 24}} labelStyle={{marginLeft: 8}}>
                        {customReasons?.map((reason, i) =>
                            // eslint-disable-next-line react/no-array-index-key
                            <option key={i} value={reason}>{reason}</option>
                        )}
                    </RadioInputs>
                )}
            </Provider>

        </div>
    );
})`
label {
  font-size: 16px;
  font-weight: 400;
  padding: 0 8px;
}`;

export default ReportSheet;
